import * as _fetch from "isomorphic-fetch";
import { Box, ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import React from "react";
import Preview from "src/views/Article/Preview";
import { Router } from "@reach/router";
import { ApolloClient, ApolloProvider, createHttpLink, InMemoryCache } from "@apollo/client";
import { theme } from "src/utils/theme";
import { apiUrl } from "src/constants";
import RedirectModal from "./RedirectModal";

const link = createHttpLink({
  fetch: _fetch as any,
  uri: apiUrl,
});

const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link,
});

const App: React.FC = ({ element }) => (
  <ApolloProvider client={apolloClient}>
    <ChakraProvider theme={theme}>
      <RedirectModal/>
      <Router>
          <Preview path="preview/article/:slug" />
      </Router>
      {element}
    </ChakraProvider>
  </ApolloProvider>
);

export default App;
